import '@shoelace-style/shoelace/dist/components/details/details.js';

/**
 * Initialize accordions
 *
 * Loop through the accordion blocks and add event listeners to show/hide the accordion content
 *
 * @return {void}
 */
function initAccordions() {
	const accordions = document.querySelectorAll('.pdm-accordion__content');

	// Close all other details when one is shown
	accordions.forEach((accordion) => {
		accordion.addEventListener('sl-show', (event) => {
			if (event.target.localName === 'sl-details') {
				[...accordion.querySelectorAll('sl-details')].map(
					(details) => (details.open = event.target === details)
				);
			}
		});
	});
}

document.addEventListener('DOMContentLoaded', () => {
	initAccordions();
});
